import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Search, LayoutList, Home, Feather, BookMarked } from 'lucide-react';
const benefits = [{
  text: 'más claridad en tu rutina diaria',
  icon: Sun
}, {
  text: 'más atención a pequeños detalles de autocuidado',
  icon: Search
}, {
  text: 'una sensación de orden y constancia',
  icon: LayoutList
}, {
  text: 'pasos fáciles de seguir desde casa',
  icon: Home
}, {
  text: 'una experiencia de bienestar más consciente',
  icon: Feather
}, {
  text: 'una herramienta práctica para consultar cuando lo necesites',
  icon: BookMarked
}];
export function Benefits() {
  return <section className="py-24 bg-charcoal text-cream" data-id="element-11">
      <div className="max-w-6xl mx-auto px-6" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-serif mb-4 text-white" data-id="element-14">
            Lo que esta guía puede aportarte
          </h2>
          <div className="w-16 h-[1px] bg-bronze mx-auto" data-id="element-15" />
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-16">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-5 p-6 border border-charcoal-light/50 bg-charcoal-light/10" data-id="element-17">
              <benefit.icon className="w-6 h-6 text-bronze shrink-0 mt-1" strokeWidth={1.5} data-id="element-18" />
              <p className="text-cream/90 font-medium leading-relaxed" data-id="element-19">
                {benefit.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}